import { showAlert } from './alerts';
const community = document.querySelector('.community');
const communityAdmin = document.querySelector('.communityAdmin');
const ranking = document.querySelector('.ranking');
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ImageUploader from 'quill-image-uploader';

if (community && !communityAdmin) {
  document.addEventListener('DOMContentLoaded', function () {
    const pseudoModal = document.getElementById('pseudoModal');

    if (pseudoModal) {
      const pseudoOverlay = pseudoModal.querySelector('.modal__overlay');
      const close = pseudoModal.querySelector('.modal__close');
      const openBtn = document.getElementById('editPseudoBtn');
      const form = document.getElementById('pseudoForm');
      const errorMsg = document.getElementById('pseudoError');

      const closePseudoModal = () => {
        pseudoModal.classList.add('hidden');
        errorMsg.classList.add('hidden');
        errorMsg.textContent = '';
      };

      openBtn.addEventListener('click', () => pseudoModal.classList.remove('hidden'));
      close.addEventListener('click', closePseudoModal);
      pseudoOverlay.addEventListener('click', closePseudoModal);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !pseudoModal.classList.contains('hidden')) {
          closePseudoModal();
        }
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const pseudo = form.pseudo.value.trim();

        errorMsg.classList.add('hidden');
        errorMsg.textContent = '';

        if (!pseudo) {
          errorMsg.textContent = 'Pseudo requis.';
          errorMsg.classList.remove('hidden');
          return;
        }

        try {
          const res = await fetch('/api/v1/users/update-pseudo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pseudo }),
          });

          const result = await res.json();

          if (result.status === 'success') {
            showAlert('success', result.message);
            closePseudoModal();
            setTimeout(() => location.reload(), 1000);
          } else {
            errorMsg.textContent = result.message || 'Erreur inconnue.';
            errorMsg.classList.remove('hidden');
          }
        } catch (err) {
          errorMsg.textContent = 'Erreur serveur.';
          errorMsg.classList.remove('hidden');
        }
      });
    }

    const deleteButtons = document.querySelectorAll('.delete-topic-btn');

    if (deleteButtons) {
      deleteButtons.forEach((btn) => {
        btn.addEventListener('click', async function () {
          const topicId = this.dataset.topicId;

          if (!topicId) {
            return showAlert('error', 'ID du topic introuvable.');
          }

          const confirmDelete = confirm('❌ Êtes-vous sûr de vouloir supprimer ce sujet ?');
          if (!confirmDelete) return;

          try {
            const response = await fetch(`/api/v1/community/topic/${topicId}`, {
              method: 'DELETE',
            });

            const result = await response.json();

            if (result.status === 'success') {
              showAlert('success', 'Sujet supprimé avec succès.');
              setTimeout(() => window.location.reload(), 1500);
            } else {
              showAlert('error', result.message || 'Erreur lors de la suppression.');
            }
          } catch (err) {
            console.error('Erreur suppression :', err);
            showAlert('error', 'Erreur serveur.');
          }
        });
      });
    }

    const newTopicForm = document.getElementById('newTopicForm');

    if (newTopicForm) {
      document.querySelectorAll('.community__newTopic--btnCat').forEach((btn) =>
        btn.addEventListener('click', () => {
          document.getElementById('category').value = btn.dataset.value;
          document.querySelectorAll('.community__newTopic--btnCat').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
        })
      );

      document.querySelectorAll('.community__newTopic--btnLang').forEach((btn) =>
        btn.addEventListener('click', () => {
          document.getElementById('language').value = btn.dataset.value;
          document.querySelectorAll('.community__newTopic--btnLang').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
        })
      );

      const editor = new Quill('#quill-editor', {
        theme: 'snow',
        placeholder: 'Décris ton problème ou ta question...',
        modules: {
          toolbar: {
            container: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline'],
              ['link', 'image'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
            handlers: {
              image: function () {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = async () => {
                  const file = input.files[0];
                  if (!file) return;

                  const formData = new FormData();
                  formData.append('image', file);

                  try {
                    const res = await fetch('/api/v1/community/upload-quill-image', {
                      method: 'POST',
                      body: formData,
                    });

                    const data = await res.json();
                    if (data.imageUrl) {
                      const range = editor.getSelection(true);
                      editor.insertEmbed(range.index, 'image', data.imageUrl);
                    } else {
                      showAlert('error', 'Erreur lors de l’upload de l’image.');
                    }
                  } catch (err) {
                    showAlert('error', 'Erreur serveur lors de l’upload.');
                  }
                };
              },
            },
          },
        },
      });

      newTopicForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        const title = newTopicForm.title.value.trim();
        const category = newTopicForm.category.value;
        const language = newTopicForm.language.value;
        const content = editor.root.innerHTML.trim();

        if (!title || !category || !language || content === '' || content === '<p><br></p>') {
          return showAlert('error', 'Tous les champs sont requis.');
        }

        try {
          const response = await fetch('/api/v1/community/create-topic', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ title, category, language, content }),
          });

          const result = await response.json();

          if (result.status === 'success') {
            showAlert(
              'success',
              'Votre sujet est en attente de validation. Il sera publié dès qu’il sera approuvé par notre équipe.'
            );
            setTimeout(() => {
              window.location.href = '/community';
            }, 3000);
          } else {
            showAlert('error', result.message || 'Erreur lors de la création du sujet.');
          }
        } catch (err) {
          showAlert('error', 'Erreur de connexion au serveur.');
        }
      });
    }

    const deleteForms = document.querySelectorAll('form.message__delete--form');

    if (deleteForms) {
      deleteForms.forEach((form) => {
        form.addEventListener('submit', async function (e) {
          e.preventDefault();

          const messageId = form.dataset.messageId;
          if (!messageId) {
            showAlert('error', 'ID du message manquant.');
            return;
          }

          if (!confirm('Confirmer la suppression de ce message ?')) return;

          try {
            const res = await fetch(`/api/v1/community/message/${messageId}`, {
              method: 'DELETE',
            });

            const result = await res.json();

            if (res.ok && (result.status === 'success' || res.status === 204)) {
              showAlert('success', 'Message supprimé.');
              setTimeout(() => window.location.reload(), 1000);
            } else {
              showAlert('error', result.message || 'Erreur lors de la suppression.');
            }
          } catch (err) {
            console.error('❌ Erreur suppression :', err);
            showAlert('error', 'Erreur serveur.');
          }
        });
      });
    }

    const replyForm = document.getElementById('replyForm');

    if (replyForm) {
      // Initialise Quill
      const quill = new Quill('#editor', {
        theme: 'snow',
        placeholder: 'Écrivez votre message ici...',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'link'],
              ['image'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
            handlers: {
              image: function () {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = async () => {
                  const file = input.files[0];
                  if (!file) return;

                  const formData = new FormData();
                  formData.append('image', file);

                  try {
                    const res = await fetch('/api/v1/community/upload-quill-image', {
                      method: 'POST',
                      body: formData,
                    });

                    const data = await res.json();

                    if (data.imageUrl) {
                      const range = quill.getSelection();
                      quill.insertEmbed(range.index, 'image', data.imageUrl);
                    } else {
                      showAlert('error', 'Erreur lors de l’upload.');
                    }
                  } catch (err) {
                    showAlert('error', 'Erreur réseau lors de l’upload.');
                  }
                };
              },
            },
          },
        },
      });

      replyForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        // Récupérer le HTML depuis Quill
        const content = quill.root.innerHTML.trim();
        if (!content || content === '<p><br></p>') {
          return showAlert('error', 'Le message ne peut pas être vide.');
        }

        const topicId = replyForm.dataset.topicId;

        try {
          const response = await fetch(`/api/v1/community/reply/${topicId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ content }),
          });

          const result = await response.json();
          if (result.status === 'success') {
            showAlert('success', 'Message envoyé avec succès.');
            setTimeout(() => location.reload(), 1500);
          } else {
            showAlert('error', result.message || "Erreur lors de l'envoi.");
          }
        } catch (err) {
          showAlert('error', 'Erreur serveur.');
        }
      });
    }

    ////////// Ouvrir modal image dans le topic
    const imgTopicModal = document.getElementById('imageModal');

    if (imgTopicModal) {
      const modalImage = document.getElementById('modalImage');
      const modalClose = imgTopicModal.querySelector('.modal__close');
      const overlay = imgTopicModal.querySelector('.modal__overlay');

      document.querySelectorAll('.community__topic--content img').forEach((img) => {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', () => {
          modalImage.src = img.src;
          imgTopicModal.classList.remove('hidden');
        });
      });

      const closeImageTopicModal = () => imgTopicModal.classList.add('hidden');
      modalClose.addEventListener('click', closeImageTopicModal);
      overlay.addEventListener('click', closeImageTopicModal);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !imgTopicModal.classList.contains('hidden')) {
          closeImageTopicModal();
        }
      });
    }
  });
}

if (ranking && !communityAdmin) {
  document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('.ranking__tabs--item');
    const tables = document.querySelectorAll('.ranking__table');

    tabButtons.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        // Remove active state
        tabButtons.forEach((b) => b.classList.remove('active'));
        tables.forEach((t) => t.classList.remove('active'));

        // Activate current
        btn.classList.add('active');
        tables[idx].classList.add('active');
      });
    });
  });
}
